module.exports = {"id":"240309","name":"Yevhen Makarenko","rating":"71","photo":"./data/images/photos/1/240309.png","club":{"name":"KV Courtrai","logo":"./data/images/clubs/KVCourtrai.png"},"positions":["MDC","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YevhenMakarenko0.json
// module id = 4407
// module chunks = 0